<template>
  <div class="deals-page">
    <div class="header"></div>
    <selected v-if="isAccess" />
    <login-required v-if="!isAccess" />
  </div>
</template>

<script>
import Selected from '@/components/deals/selected'
import LoginRequired from '@/components/common/login-required'

export default {
  name: 'deals',
  components: {
    Selected,
    LoginRequired
  },
  computed: {
    isAccess () {
      return this.$store.getters['tokens/isAccessToken']
    }
  }
}
</script>

<style lang="scss" scoped>
.deals-page {
  padding-top: 150px;
  .header {
    height: 75px;
    background-color: rgb(24, 48, 90);
    width: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
